module.exports = __webpack_public_path__ + "img/center back length to hem.fef61797.png";